function _forceRedraw (element, delay) {
  if (!element) {
    return
  }

  console.log('Forcing Redraw on element', element)
  
  const n = document.createTextNode(' ')
  const disp = element.style.display
  
  element.appendChild(n)
  element.style.display = 'none'
  
  setTimeout(() => {
    element.style.display = disp
    n.parentNode.removeChild(n)
  }, delay || 50)
}

export const forceRedraw = _forceRedraw

/**
 * Normalizes a value to an array. Handles JSON strings, arrays, or null/undefined.
 * @param {any} value - The value to normalize
 * @returns {Array} - The normalized array, or empty array if invalid
 */
export function normalizeArray(value) {
  if (Array.isArray(value)) {
    return value
  }
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value)
      return Array.isArray(parsed) ? parsed : []
    } catch (e) {
      return []
    }
  }
  return []
}